import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import { Button, useTheme } from '@mui/material';
import { useTranslation } from '../../services/translation/hooks/useTranslation';
type Props = {
  onDownloadClick: () => void;
  numRowsSelected?: number | null;
};

const DownloadTableButton = ({ onDownloadClick, numRowsSelected }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <Button
      variant='outlined'
      color='primary'
      sx={{
        p: '0.63rem',
        pr: '1rem',
        color: theme.colors.canopy.content.primary,
        border: `1px solid ${theme.colors.canopy.grey[200]}`,
        '&:hover': {
          border: `1px solid ${theme.colors.canopy.grey[100]}`,
        },
      }}
      onClick={onDownloadClick}
    >
      <DownloadOutlinedIcon
        sx={{ color: theme.colors.canopy.content.secondary, mr: '0.1875rem' }}
      />
      {numRowsSelected
        ? `${t('Download Selected')} (${numRowsSelected})`
        : t('Download')}
    </Button>
  );
};

export default DownloadTableButton;
